import { faCog } from '@fortawesome/free-solid-svg-icons'
import React, { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { BetaSpan, Spinner } from '../../../../../App/Components'
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../App/Hooks/reduxHooks'
import { getEstablishment } from '../../../../../Establishment/Store/actions'
import { getCurrentUser } from '../../../../../User/Store/actions'

import { settingOptions } from './data/settingOptions'
import {
  ButtonWrapper,
  CogIcon,
  IconText,
  IconWrapper,
  SettingIcon,
} from './style'

export const ModalContent = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { permissions, userPermissions, isPartner } = useAppSelector(state => ({
    permissions: state.establishment.active?.permissions,
    userPermissions: state.users.currentUser?.permissions,
    isPartner: state.users.currentUser?.isPartner,
  }))

  useEffect(() => {
    if (typeof permissions === 'undefined') {
      dispatch(getEstablishment())
      dispatch(getCurrentUser())
    }
  }, [])

  if (
    typeof permissions === 'undefined' ||
    typeof userPermissions === 'undefined'
  ) {
    return <Spinner />
  }
  const mapSettingsToTile = settingOptions
    .filter(setting => {
      const modulePermissionCheck =
        setting.modulePermissions.length === 0 ||
        setting.modulePermissions
          .map(permission => permissions.indexOf(permission) > -1)
          .includes(true)

      const userPermissionCheck =
        setting.userPermissions.length === 0 ||
        setting.userPermissions
          .map(
            permission =>
              permission in userPermissions && userPermissions[permission],
          )
          .includes(true)

      if (isPartner && setting.isLimitedToPartner) {
        return (
          modulePermissionCheck &&
          userPermissionCheck &&
          setting.isLimitedToPartner
        )
      }

      return (
        modulePermissionCheck &&
        userPermissionCheck &&
        !setting.isLimitedToPartner
      )
    })
    .map((setting, index) => {
      const navigationToSetting = (event: MouseEvent): void => {
        if (event.metaKey) {
          window.open(setting.url, '_blank')
        } else {
          window.location.replace(setting.url)
        }
      }

      return (
        <Fragment key={`setting${setting.name}`}>
          {index === 4 ? (
            <div style={{ flexBasis: '100%', height: 0 }} />
          ) : null}
          <ButtonWrapper
            btnColor={setting.color}
            key={`${setting.name}${index}`}
            onClick={event => navigationToSetting(event)}>
            <IconWrapper>
              <SettingIcon icon={setting.icon} />
              {setting.isBeta ? (
                <BetaSpan
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: '-17px',
                  }}
                />
              ) : null}
              <CogIcon icon={faCog} color={'#303640'} />
            </IconWrapper>
            <IconText>{t(setting.name)}</IconText>
          </ButtonWrapper>
        </Fragment>
      )
    })

  return <>{mapSettingsToTile}</>
}
